export default __webpack_public_path__ + "static/media/404BG.cdb1a3e2.svg";